var _g;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M183.87,53.49a17.74,17.74,0,0,1-15.48,8.62c-10.37,0-17.92-7.6-17.92-17.38,0-9.21,7.55-16.9,17.92-16.9,7.06,0,12.61,3.31,15.58,8.28l-6.77,3.94a10,10,0,0,0-18.65,4.68,9.76,9.76,0,0,0,9.84,9.88,9.6,9.6,0,0,0,8.71-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.81,45a17.09,17.09,0,1,1-17.09-17.14A17.16,17.16,0,0,1,219.81,45Zm-26.88,0a9.74,9.74,0,1,0,9.79-9.69A9.75,9.75,0,0,0,192.93,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,61.52h-8L232.13,41.27V61.52h-8V28.41h8l16.75,20.21V28.41h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.79,44.92c0,9.64-7.15,16.6-17.48,16.6H262.66V28.46l14.65-.05C288.22,28.37,294.79,35.38,294.79,44.92Zm-24.15,9.2h6.67c5.55,0,9.4-3.65,9.4-9.2,0-5.94-3.75-9.11-9.4-9.11h-6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.43,45a17.09,17.09,0,1,1-17.09-17.14A17.16,17.16,0,0,1,332.43,45Zm-26.88,0a9.74,9.74,0,1,0,9.79-9.69A9.76,9.76,0,0,0,305.55,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.76,95.26h-16l-2.19,5.16h-8.47L164.3,67.31h8.91l14.21,33.11H178.9ZM174,88.73l-5.16-12.36-5.26,12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.82,95.16l11.1-11L187.23,72.42l5.7-5.69,11.68,11.78,12-11.78,5.7,5.64L210.21,84.3l11.06,11-5.8,5.74L204.57,90l-11.06,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.32,100.42h-8V67.31h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.16,77.78h-7.94c0-1.66-1.94-3.9-5.35-3.9-2.39,0-5.31,1.07-5.31,3,0,1.61,2.19,2.24,6.87,3.46C259.64,81.67,267,83.43,267,90.73c0,6.33-5.55,10.27-13.29,10.27C243.33,101,239,94,239,88.83h7.94s.63,5.26,7.2,5.26c3.56,0,4.87-1.51,4.87-2.92,0-2.1-2.77-2.83-5.84-3.56-5-1.16-13.68-3-13.68-10.37,0-6,5.94-10.51,13.49-10.51C261.58,66.73,266.16,72.62,266.16,77.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.67,
    y: 83.7,
    width: 24.48,
    height: 24.48,
    transform: "translate(-34.3 139.05) rotate(-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.23,
    y: 34.76,
    width: 24.48,
    height: 24.48,
    transform: "translate(23.2 129.72) rotate(-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.59,
    y: 4.52,
    width: 24.48,
    height: 24.48,
    transform: "translate(10.1 49.08) rotate(-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.19,
    y: 53.81,
    width: 24.48,
    height: 24.48,
    transform: "translate(-47.63 58.77) rotate(-66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.75 57.47 107.97 5.31 96.04 0 54.36 93.62 66.29 98.93 79.44 69.4 127.87 90.97 133.19 79.03 84.75 57.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.01 13.76 53.74 43.55 5.31 21.99 0 33.93 48.43 55.49 25.21 107.65 37.15 112.96 78.95 19.07 67.01 13.76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77391aee.svg";
export { ForwardRef as ReactComponent };